"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var utils_1 = require("../../../core/utils");
/**
 * Sellout target attributes (LOG-2025).
 * @author Radek Beran
 */


var SelloutTarget =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutTarget, _DomainObject_1$Domai);

  /**
   * Creates new targets for release category.
   *
   * @param id unique id of this object
   * @param releaseId release id
   * @param categoryId category id
   * @param targetMargin BM2 (margin) in %
   * @param targetProfit profit (final price - purchase price) in CZK
   */
  function SelloutTarget(id, releaseId, categoryId, targetMargin, targetProfit) {
    var _this;

    _classCallCheck(this, SelloutTarget);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutTarget).call(this));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.categoryId = categoryId;
    _this.targetMargin = targetMargin;
    _this.targetProfit = targetProfit;
    return _this;
  }

  _createClass(SelloutTarget, null, [{
    key: "empty",
    value: function empty(releaseId, categoryId) {
      return new SelloutTarget(utils_1.Utils.VOID_ID, releaseId, categoryId, null, null);
    }
  }]);

  return SelloutTarget;
}(DomainObject_1.DomainObject);

exports.SelloutTarget = SelloutTarget;

SelloutTarget.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutTarget.name);
  return {
    id: builder.id('id'),
    releaseId: builder.str('releaseId'),
    categoryId: builder.str('categoryId'),
    targetMargin: builder.opt(builder.bigNum('targetMargin')),
    targetProfit: builder.opt(builder.bigNum('targetProfit'))
  };
}();